module.exports = {
    "dismiss": `Negeren`
};


//# sourceMappingURL=nl-NL.main.js.map
